import React, { useState } from 'react';
import AdminService from '../../../API/AdminService';
import cl from './Forum.module.css';
import logger from '../../../utils/logger';
import { IconSearch, IconClose, IconRefresh } from '../../../components/Icons';

const ForumSearch = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!query.trim()) return;

        try {
            setLoading(true);
            const response = await AdminService.searchForum(query.trim());
            setResults(response.data);
            setShowResults(true);
        } catch (error) {
            logger.error('Ошибка поиска:', error);
        } finally {
            setLoading(false);
        }
    };

    const clearSearch = () => {
        setQuery('');
        setResults(null);
        setShowResults(false);
    };

    return (
        <div className={cl.searchContainer}>
            <form onSubmit={handleSearch} className={cl.searchForm}>
                <span className={cl.searchInputIcon}>
                    <IconSearch width={16} height={16}/>
                </span>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Поиск по форуму…"
                    className={cl.searchInput}
                />
                {query && (
                    <button
                        type="button"
                        onClick={clearSearch}
                        className={cl.searchClearButton}
                        aria-label="Очистить"
                    >
                        <IconClose width={13} height={13}/>
                    </button>
                )}
                <button
                    type="submit"
                    className={cl.searchSubmitButton}
                    disabled={loading || !query.trim()}
                    aria-label="Найти"
                >
                    {loading
                        ? <IconRefresh width={14} height={14} className={cl.searchSpinIcon}/>
                        : <IconSearch width={14} height={14}/>}
                </button>
            </form>

            {showResults && results && (
                <div className={cl.searchResults}>
                    <div className={cl.resultsHeader}>
                        <h3>Результаты</h3>
                        <button
                            onClick={() => setShowResults(false)}
                            className={cl.resultsClose}
                            aria-label="Закрыть"
                        >
                            <IconClose width={14} height={14}/>
                        </button>
                    </div>

                    {results.topics && results.topics.length > 0 && (
                        <div className={cl.resultsSection}>
                            <h4>Темы ({results.topics.length})</h4>
                            {results.topics.map(topic => (
                                <div key={topic.id} className={cl.resultItem}>
                                    <a href={`/main/forum/topics/${topic.id}`}>
                                        {topic.title}
                                    </a>
                                    <p>{AdminService.truncateText(topic.content, 100)}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {results.comments && results.comments.length > 0 && (
                        <div className={cl.resultsSection}>
                            <h4>Комментарии ({results.comments.length})</h4>
                            {results.comments.map(comment => (
                                <div key={comment.id} className={cl.resultItem}>
                                    <a href={`/main/forum/topics/${comment.topic_id}`}>
                                        {comment.topic_title}
                                    </a>
                                    <p>{AdminService.truncateText(comment.content, 100)}</p>
                                    <small>от {comment.author_name}</small>
                                </div>
                            ))}
                        </div>
                    )}

                    {(!results.topics || results.topics.length === 0) &&
                     (!results.comments || results.comments.length === 0) && (
                        <p className={cl.noResults}>По вашему запросу ничего не найдено</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ForumSearch;
